<script setup lang="ts">
import BaseTable, { DataTableHeader } from '../../base/table/BaseTable.vue'
import { useWalletState, WalletState, WalletTransaction } from '../../../utilities/account/useWallet'
import { formatCurrency, formatDate } from '../../../utilities/helpers'
import { getTransactionPaymentMethod, getTransactionTitle } from './useWalletTransactions'

import { i18n } from '../../../localization'

defineProps<{
    transactions: WalletTransaction[]
}>()

const walletStore = useWalletState() as WalletState

const tableHeaders: DataTableHeader[] = [
    {
        text: i18n.global.t('wallet.transaction_date'),
        value: 'date',
        valueFormatter: formatDate,
    },
    {
        text: i18n.global.t('wallet.transaction_title'),
        value: 'transaction_title',
        itemFormatter: getTransactionTitle,
    },
    {
        text: i18n.global.t('wallet.transaction_payment_method'),
        value: 'method',
        itemFormatter: getTransactionPaymentMethod,
    },
    {
        text: i18n.global.t('wallet.transaction_amount'),
        value: 'signed_amount',
        classes: 'text-right',
    },
]
</script>

<template>
    <BaseTable :items="transactions" :headers="tableHeaders" paginate>
        <template #item.transaction_title="{ value }">
            <span class="text-gray-500">
                {{ value }}
            </span>
        </template>
        <template #item.signed_amount="{ value }">
            <span :class="value < 0 ? 'text-red-600' : 'text-green-600'">
                {{ formatCurrency(value, walletStore.wallet.currency) }}
            </span>
        </template>
    </BaseTable>
</template>
